/**
 * Painel que desliza da direita (formulários longos, detalhes). No celular
 * ocupa a tela inteira. Fecha com Esc ou clique no fundo.
 */
import { X } from "lucide-react";
import { useEffect, type ReactNode } from "react";
import { Botao } from "./botao";

export function PainelLateral({
  aberto,
  onFechar,
  titulo,
  children,
  rodape,
}: {
  aberto: boolean;
  onFechar: () => void;
  titulo: string;
  children: ReactNode;
  rodape?: ReactNode;
}) {
  useEffect(() => {
    if (!aberto) return;
    const esc = (e: KeyboardEvent) => e.key === "Escape" && onFechar();
    document.addEventListener("keydown", esc);
    return () => document.removeEventListener("keydown", esc);
  }, [aberto, onFechar]);
  if (!aberto) return null;
  return (
    <div className="fixed inset-0 z-50 flex justify-end">
      <button
        aria-label="Fechar"
        className="absolute inset-0 bg-[rgba(28,24,21,0.45)]"
        onClick={onFechar}
      />
      <section
        role="dialog"
        aria-label={titulo}
        className="relative flex h-full w-full max-w-[480px] flex-col bg-white shadow-lg"
      >
        <header className="flex h-16 shrink-0 items-center justify-between border-b border-neutral-200 px-5">
          <h2 className="text-lg">{titulo}</h2>
          <Botao variante="fantasma" tamanho="icone" onClick={onFechar} aria-label="Fechar">
            <X size={18} strokeWidth={1.75} />
          </Botao>
        </header>
        <div className="rolagem-fina flex-1 overflow-y-auto p-5">{children}</div>
        {rodape && (
          <footer className="area-segura-inferior flex justify-end gap-2 border-t border-neutral-200 p-4">
            {rodape}
          </footer>
        )}
      </section>
    </div>
  );
}
